import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../../api/$api";
import { CreateSessionData, TDataToken, TQueries } from "./type";

const createSession = (
  data: TDataToken,
  payload: CreateSessionData
) => {
  return $api
    .post("/admin/bulks/upsert", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useCreateSession = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, CreateSessionData>
) => {
  return useMutation({
    mutationFn: (payload:CreateSessionData) =>
        createSession(data, payload),
    ...config
  });
};


const getSessions = (
    data: TDataToken,
    payload: TQueries
) => {
    return $api
        .get(`/admin/bulks/org/${payload?.orgID}`, { token: data.accessToken})
        .then((response) => {
            return response;
        });
};

export const useGetSessions = (data: TDataToken, queries: TQueries, config?: {}) => {
    return useQuery({
        queryKey: ["org-invite-sessions", queries],
        queryFn: () => getSessions(data, queries),
        ...config as UseQueryOptions<any>
    });
};


const sendInvitation = (
  data: TDataToken,
  payload: CreateSessionData
) => {
  return $api
    .post("/admin/bulks/process-bulks", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useSendInvitation = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, CreateSessionData>
) => {
  return useMutation({
    mutationFn: (payload:CreateSessionData) =>
      sendInvitation(data, payload),
    ...config
  });
};


const runValidation = (
  data: TDataToken,
  payload: CreateSessionData
) => {
  return $api
    .post("/admin/invite/run-validation", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useRunValidation = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, CreateSessionData>
) => {
  return useMutation({
    mutationFn: (payload:CreateSessionData) =>
      runValidation(data, payload),
    ...config
  });
};